import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import { useModalService } from "./../../ricos-modals/index.js";
import { DropdownModal } from "./../dropdown-modal/dropdown-modal.js";
import { ListItemDivider } from "./../list-item-divider/list-item-divider.js";
import { ListItemSelect } from "./../list-item-select/list-item-select.js";
import { ListItemToggle } from "./../list-item-toggle/list-item-toggle.js";
import { DEFAULT_OPTIONS, NODE_ALIGNMENT_BUTTONS, TEXT_WRAP_TOGGLE } from "./consts.js";
const NodeAlignmentDropdown = ({
  modalId,
  getSelectedAlignment,
  onClick,
  options: optionsOverride,
  getSelectedTextWrap,
  onTextWrapToggle,
  isTextWrapDisabled
}) => {
  const { t } = useContext(RicosContext);
  const modalService = useModalService();
  const selectedAlignment = getSelectedAlignment();
  const disableTextWrap = isTextWrapDisabled?.() || selectedAlignment === "CENTER";
  const alignmentOptions = (optionsOverride ?? DEFAULT_OPTIONS).map(
    (option) => NODE_ALIGNMENT_BUTTONS[option]
  );
  const AlignmentDropdownOptions = alignmentOptions.map(
    ({ dataHook, iconSmall: Icon, text, commandKey }) => /* @__PURE__ */ React.createElement(
      ListItemSelect,
      {
        key: commandKey,
        dataHook,
        prefix: /* @__PURE__ */ React.createElement(Icon, null),
        title: t(text),
        selected: commandKey === selectedAlignment,
        onSelect: () => onClick(commandKey)
      }
    )
  );
  return /* @__PURE__ */ React.createElement(
    DropdownModal,
    {
      onCloseButtonClick: () => modalService.closeModal(modalId),
      title: t("NodeAlignmentDropdown_Title"),
      options: optionsOverride?.length ? AlignmentDropdownOptions : [
        ...AlignmentDropdownOptions,
        ...[
          /* @__PURE__ */ React.createElement(ListItemDivider, { key: "divider" }),
          /* @__PURE__ */ React.createElement(
            TextWrapToggle,
            {
              key: TEXT_WRAP_TOGGLE.commandKey,
              onTextWrapToggle: onTextWrapToggle ?? (() => {
              }),
              getSelectedTextWrap: getSelectedTextWrap ?? (() => true),
              disableTextWrap,
              selectedAlignment
            }
          )
        ]
      ]
    }
  );
};
const TextWrapToggle = ({ onTextWrapToggle, getSelectedTextWrap, disableTextWrap, selectedAlignment }) => {
  const { t } = useContext(RicosContext);
  return /* @__PURE__ */ React.createElement(
    ListItemToggle,
    {
      key: TEXT_WRAP_TOGGLE.commandKey,
      dataHook: TEXT_WRAP_TOGGLE.dataHook,
      onChange: onTextWrapToggle ?? (() => {
      }),
      title: t(TEXT_WRAP_TOGGLE.text),
      selected: disableTextWrap ? false : getSelectedTextWrap?.() ?? true,
      infoContent: disableTextWrap ? t(
        selectedAlignment === "CENTER" ? TEXT_WRAP_TOGGLE.infoIconTextAlignedCenter : TEXT_WRAP_TOGGLE.infoIconTextUnsupportedContainer
      ) : void 0,
      disabled: disableTextWrap
    }
  );
};
export {
  NodeAlignmentDropdown
};
//# sourceMappingURL=node-alignment-dropdown.js.map
